import React from "react";
import { AboutSection } from "./designcss/aboutcss";
import MyImage from "./images/passport_id.jpg";

const About = () => {
  return (
    <AboutSection>
      <div className="container">
        <div className="image-wrapper">
          <img src={MyImage} alt="Albiemer Porte" />
        </div>

        <div className="content">
          <span className="tag">About Me</span>
          <h2>Building Intelligent & Practical Systems</h2>
          <p>
            Hi, I'm <strong>Albiemer Porte</strong> — a Computer Science graduating student
            focused on <strong>Edge Systems, Software Development,</strong> and
            <strong> modern web technologies</strong>.
          </p>
          <p>
            I build real-world solutions including embedded systems,
            kiosk applications, and full-stack web platforms.
            My goal is to create efficient, scalable, and impactful systems.
          </p>

          <hr style={{ margin: '20px 0', border: '0', borderTop: '1px solid #eee' }} />

          <div className="contact-details" style={{ fontSize: '0.9rem', lineHeight: '1.8' }}>
            <p style={{ margin: '5px 0' }}>
              <strong>📞 Phone:</strong> 09669685652
            </p>
            <p style={{ margin: '5px 0' }}>
              <strong>📧 Email:</strong> <a href="mailto:albiemerporte@gmail.com" style={{ color: '#007bff', textDecoration: 'none' }}>albiemerporte@gmail.com</a>
            </p>
            <p style={{ margin: '5px 0' }}>
              <strong>🌐 Portfolio:</strong> <a href="https://albiemer.singlobby.com" target="_blank" rel="noreferrer" style={{ color: '#007bff', textDecoration: 'none' }}>albiemer.singlobby.com</a>
            </p>
          </div>
        </div>
      </div>
    </AboutSection>
  );
};

export default About;